import React from 'react';

const AwardCategory = (props) => (
    <li className="media">
        <div className="media-body-awards">
            <h3 className="award-heading">{props.category.title}</h3>
            <ul className="media-list">
                {props.children}
            </ul>
        </div>
    </li>
);


export default AwardCategory;


// WEBPACK FOOTER //
// ./src/Awards/AwardCategory.js